import {
  RECEIVE_GET_VAT_RATE,
  RECEIVE_GET_VAT_RATES,
  RECEIVE_PERSIST_VAT_RATE,
} from 'common/redux/actions/vatRate'
import { RESET_STATE } from 'common/redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PERSIST_VAT_RATE:
    case RECEIVE_GET_VAT_RATE:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
        },
      }
    case RECEIVE_GET_VAT_RATES:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
        },
      }

    case RESET_STATE:
      if (action.state === 'vatRate') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }

      return state
    default:
      return state
  }
}
